import React from 'react';

// eslint-disable-next-line import/no-unresolved
import scrumSVG from 'assets/resources/icon/scrum_icon.svg';
import SoftwaresSingleItem from './SoftwaresSingleItem';
import OptimizedImage from '../OptimizedImage';
import ImgHTML from '../ImgHTML';
import img from '../../../static/img/5-ways-it-sector-will-be-influenced-by-coronavirus.jpg';

export default ({
  content: { title, subtitle, description, businessList },
  withoutLine,
  withText
}) => {
  return (
    <div className="container">
      <div className="softwares pt-5">
        <div className="row">
          <div className="col-md-12 col-md-auto">
            <h2
              className={`subtitle bigger ${withoutLine ? 'without' : ''}`}
              style={{ paddingBottom: '36px' }}
            >
              {title}
            </h2>
            <div className="content">
              <p>{subtitle}</p>
            </div>
          </div>
          <div className="col-lg-8 col-md-12">
            <div className="left-beam">
              <div className="icon-beam horizontal">
                <div className="row">
                  {businessList.map(item => (
                    <SoftwaresSingleItem item={item} key={item.title} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`col-lg-4 col-md-12 ${withText &&
              'mvp-border mt-5 p-4'}`}
          >
            <div className="right-beam ">
              {!withText ? (
                <>
                  <OptimizedImage
                    src="pages/scrum_photo.png"
                    className="img-fluid img-head"
                    alt="scrum photo"
                    title="scrum photo"
                  />
                  <div className="basis">
                    <div className="icon">
                      <ImgHTML src={scrumSVG} alt="scrum svg icon" />
                    </div>
                    <div className="content">
                      <p>{description}</p>
                    </div>
                  </div>
                </>
              ) : (
                <div className="">
                  <ImgHTML src={img} alt="scrum svg icon" className="mr-3" />
                  <div className="d-flex">
                    <h2 className="d-flex align-items-center my-3">
                      What does MVP stand for in business?
                    </h2>
                  </div>
                  <div className="what-is">
                    <span className="float-left">
                      <ImgHTML
                        src={scrumSVG}
                        alt="scrum svg icon"
                        className="mr-3"
                      />
                    </span>
                    <p className="d-inline">
                      MVP (minimum viable product) is a startup and product
                      development approach in which only the core features are
                      built. This way, the business idea can be quickly and
                      cost-efficiently verified with real customers. The
                      decision on further development can be based on MVP
                      response.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
